import { Box, Button } from '@mui/material';
import FilePreview from 'src/components/modal/UploadModal/FilePreview';
import { colors } from 'src/styles/theme';

const FileUpload = ({
  file,
  onUpload = () => {},
  onCancel = () => {},
  onRemove = () => {},
  loaded,
}) => {
  return (
    <Box>
      <FilePreview name={file.name} size={file.size} loaded={loaded} />
      <Box display="flex" justifyContent="space-between" mt="40px">
        <Button
          onClick={onCancel}
          disabled={!loaded}
          sx={{
            backgroundColor: colors.grey[100],
            color: colors.grey[500],
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '20px',
            textTransform: 'uppercase',
            borderRadius: '4px',
            height: '48px',
            minWidth: '120px',
            width: '192px',
            '&:hover': {
              backgroundColor: colors.grey[200],
            },
            '&:disabled': {
              backgroundColor: colors.grey[100],
              color: colors.grey[400],
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onRemove}
          disabled={!loaded}
          sx={{
            backgroundColor: colors.grey[100],
            color: colors.error.main,
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '20px',
            textTransform: 'uppercase',
            borderRadius: '4px',
            height: '48px',
            minWidth: '120px',
            width: '192px',
            border: `1px solid ${colors.error.main}`,
            '&:hover': {
              backgroundColor: colors.error.main,
              color: colors.white,
            },
            '&:disabled': {
              backgroundColor: colors.grey[100],
              color: colors.grey[400],
              border: `1px solid ${colors.grey[400]}`,
            },
          }}
        >
          Clear
        </Button>
        <Button
          onClick={onUpload}
          disabled={!loaded}
          sx={{
            backgroundColor: colors.secondary.main,
            color: colors.white,
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '20px',
            textTransform: 'uppercase',
            borderRadius: '4px',
            height: '48px',
            minWidth: '140px',
            width: '192px',
            '&:hover': {
              backgroundColor: colors.secondary.dark,
            },
            '&:disabled': {
              backgroundColor: colors.secondary.light,
              color: colors.white,
            },
          }}
        >
          Import
        </Button>
      </Box>
    </Box>
  );
};

export default FileUpload;
